import fp from 'lodash/fp';


export const isInfoError = error => fp.get('response.data.ErrorType', error) === 'Info' || fp.get('response.data.errorType', error) === 'Info';

export const getErrorTitle = error => fp.get('response.data.title', error) ?? fp.getOr(error, 'response.data.Title', error);
